export namespace InvoiceEventClassification {
  export class Enum {
    static readonly AUTHORIZATION_NOTFOUND = new Enum(
      'AUTHORIZATION_NOTFOUND',
      'Pedido não encontrado',
      true
    )
    static readonly CANCELED_AUTHORIZATION = new Enum(
      'CANCELED_AUTHORIZATION',
      'Pedido cancelado',
      true
    )
    static readonly MANUAL_CONCILIATED = new Enum(
      'MANUAL_CONCILIATED',
      'Conciliado manualmente',
      false,
      true,
      false,
      true
    )
    static readonly AUTOMATIC_CONCILIATED = new Enum(
      'AUTOMATIC_CONCILIATED',
      'Conciliado automáticamente',
      false,
      false,
      false,
      false,
      false
    )
    static readonly INVALID_AMOUNT = new Enum('INVALID_AMOUNT', 'Valor incorreto', true)
    static readonly MONTHLY_PAYMENT = new Enum('MONTHLY_PAYMENT', 'Parceiro mensalizado')
    static readonly WITHOUT_RELATION = new Enum('WITHOUT_RELATION', 'Sem relação com o produto')
    static readonly BUNDLE_PAYMENT = new Enum('BUNDLE_PAYMENT', 'Parceiro bundle')
    static readonly MULTIPLE_AUTHORIZATION = new Enum('MULTIPLE_AUTHORIZATION', 'Múltiplos pedidos')
    static readonly OTHERS = new Enum('OTHERS', 'Outro', false, false, true, true)

    private constructor(
      public readonly value: string,
      public readonly label: string,
      public readonly hasTicketId: boolean = false,
      public readonly hasOrderId: boolean = false,
      public readonly requiredComment: boolean = false,
      public readonly isReclassifiable: boolean = false,
      public readonly isClassifiable: boolean = true
    ) {}
  }

  export const findByValue = (
    value: string | null
  ): InvoiceEventClassification.Enum | undefined => {
    return Object.values(InvoiceEventClassification.Enum).find(i => i.value === value)
  }

  export const getAll = (): Enum[] => {
    return Object.values(InvoiceEventClassification.Enum)
  }
}
